export default __webpack_public_path__ + "static/media/BM_RenderCamera_13_BedroomC_02+Interior+Light_Scheme+Bedroom.3f8eba42.jpg";